import {
  DEPART_DATE_ERROR,
  NO_AIRPORT_ERROR,
  ORIGIN_DEST_SAME_ERROR,
  RETURN_DATE_ERROR,
  TRAVEL_DATES_ERROR
} from '../constants'

export default function validate(values, isTripRound) {
  let errors = {}
  if (!values.origin) {
    errors.origin = NO_AIRPORT_ERROR
    return errors
  } else errors.origin = ''
  if (!values.destination) {
    errors.destination = NO_AIRPORT_ERROR
    return errors
  } else errors.destination = ''
  if (isTripRound && values.depDate === '' && values.retDate === '') {
    errors.bothDatesRequired = TRAVEL_DATES_ERROR
    return errors
  } else errors.bothDatesRequired = ''
  if (values.depDate === '' && (values.retDate !== '' || !isTripRound)) {
    errors.depDate = DEPART_DATE_ERROR
    return errors
  } else errors.depDate = ''
  if (values.retDate === '' && values.depDate !== '' && isTripRound) {
    errors.retDate = RETURN_DATE_ERROR
    return errors
  } else errors.retDate = ''

  if (values.origin === values.destination && values.origin !== '') {
    errors.notSame = ORIGIN_DEST_SAME_ERROR
    return errors
  } else errors.notSame = ''

  return {}
}
